import { render, staticRenderFns } from "./placedetails.vue?vue&type=template&id=55de2018&"
import script from "./placedetails.vue?vue&type=script&lang=js&"
export * from "./placedetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports